import script from "./KeywordInput.vue?vue&type=script&setup=true&lang=js"
export * from "./KeywordInput.vue?vue&type=script&setup=true&lang=js"

import "./KeywordInput.vue?vue&type=style&index=0&id=953b3840&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-953b3840"]])

export default __exports__